import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { openConfirmation } from 'helpers/Confirmation';
import _ from 'lodash';
import { CanUserEditAccessFunding } from 'appconstants/Permission';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import EditFundingRow from './EditFundingRow';
import { FundingInfoColumns } from '../gridcolumns';

let setEditingFundingFlag;
const FundingInfoSummary = props => {
  const {
    data, saveFundingInfo, setState, state, onSetIndex, regSteps, onDataLoad, fundingIndex
  } = props;

  const saveFund = () => {
    saveFundingInfo(state);
  };

  const RowClicked = (row, index) => {
    if (index >= 0) onSetIndex({ highlightRow:index });
  };

  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingFundingFlag = (flg) => {
      setEditing(flg);
      setState({});
    };

    return (
      <EditFundingRow
        state={state || row}
        regSteps={regSteps}
        setEditing={setEditing}
        setState={setState}
        defaultRow={row}
      />
    );
  };
  return (
    <ValidatorForm onSubmit={saveFund}>
      <GridTable
        tag={`${TE.ID}fundingdetails${TE.TABLE}`}
        title="Funding Details"
        exportTitle={`Funding Details-${useGetPathProtocol()}-Funding`}
        columns={FundingInfoColumns}
        user={GetUserFullName()}
        rows={data}
        editable
        deletable
        filterable
        sortable
        enableToolbar
        editMode={CanUserEditAccessFunding()}
        renderEditRow={RenderEditRow}
        onRowClicked={RowClicked}
        rowEditable={() => true}
        rowDeletable={() => false}
        highlightRowObject={fundingIndex}
        recordPerPage={10}
        onDataLoad={onDataLoad}
        toPdf={false}
      />
    </ValidatorForm>
  );
};
const FundingInfo = compose(
  withAppContext,
  withState('state', 'setState', {}),
  withHandlers({
    saveFundingInfo: props => postBody => {
      const confirmSaveFunding = () => {
        const {
          saveFundingInfo
        } = props;
        saveFundingInfo(postBody);
        setEditingFundingFlag(false);
      };
      openConfirmation({
        message: 'Do you want to save the funding info?',
        onAction: confirmSaveFunding,
        name: 'confirm_save_funding'
      });
    }
    // delFundingInfo: props => verId => {
    //   const confirmDelFunding = () => {
    //     const {
    //       onDeleteVersion, context, protocolId, setState
    //     } = props;
    //     bindLogger(onDeleteVersion, context)(protocolId, verId);
    //     setState({});
    //     setEditingFundingFlag(false);
    //   };
    //   openConfirmation({
    //     message: 'Delete Funding',
    //     onAction: confirmDelFunding
    //   });
    // }
  })
)(FundingInfoSummary);

export { FundingInfo };
